import * as Schema from "effect/Schema";

/** Public tool failures contain safe explanations, never provider response bodies. */
export class ToolExecutionError extends Schema.TaggedErrorClass<ToolExecutionError>()(
  "ToolExecutionError",
  {
    reason: Schema.Literals([
      "timed_out",
      "unavailable",
      "declined",
      "interrupted",
      "invalid_result",
      "failed",
    ]),
    message: Schema.String,
  },
) {}
